import Vue from 'vue';
import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';

import Workspace from '../pages/Workspace.vue';

import store from '../store';
import * as constants from "../utils/constants";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../pages/course/Courses.vue'),
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../pages/Dashboard.vue'),
    },
    {
        path: '/profile',
        name: 'auth.profile',
        component: () => import('../pages/auth/Profile.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/workspace/:topicId?',
        name: 'workspace',
        component: Workspace,
        // meta: {
        //     auth: true,
        // },
    },
    {
        path: '/login',
        name: 'auth.login',
        component: () => import('../pages/course/Courses.vue'),
        meta: {
            guest: true,
        },
    },
    {
        path: '/register',
        name: 'auth.register',
        component: () => import('../pages/auth/Register.vue'),
        meta: {
            guest: true,
        },
    },
    {
        path: '/password/reset/:token/:email',
        name: 'reset.password',
        component: () => import('../pages/course/Courses.vue'),
        meta: {
            guest: true,
        },
    },
    {
        path: '/course/:course_id/lesson/:lesson_id/topic/:topic_id',
        name: 'topic',
        component: () => import('../pages/topic/TopicContent'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/course/:course_id/lesson/:lesson_id/topic/:topic_id/quiz/:quiz_id',
        name: 'quiz',
        component: () => import('../pages/quizzes/Quiz'),
        meta: {
            auth: true,
        },
    },
    // {
    //     path: '/courses',
    //     name: 'course.courses',
    //     component: () => import('../pages/course/Courses.vue'),
    //     meta: {
    //         auth: true,
    //     },
    // },
    {
        path: '/course/:course_id/lessons',
        name: 'course.lessons',
        component: () => import('../pages/lesson/Lessons.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/course/:course_id/map',
        name: 'course.map',
        component: () => import('../pages/course/CourseMap.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/course/:course_id/lesson/:lesson_id/topics',
        name: 'lesson.topics',
        component: () => import('../pages/topic/Topics.vue'),
        meta: {
            auth: true,
        },
    },

    /**
     * Must be the last entry in array.
     */
    {
        path: '*',
        component: () => import('../pages/NotFound.vue'),
    },
];

const router = new VueRouter({
    routes,
    mode: 'hash',
    linkActiveClass: 'active',
    scrollBehavior() {
        return {
            x: 0,
            y: 0,
        };
    },
});

// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.auth) && !store.getters['auth/logged']) {
//         /**
//          * If the user is not authenticated and visits
//          * a page that requires authentication, redirect to the login page
//          */
//         next({
//             name: 'auth.login',
//             query: {
//                 redirect: to.fullPath,
//             },
//         });
//     } else if (to.matched.some(record => record.meta.guest) && store.getters['auth/logged']) {
//         /**
//          * If the user is authenticated and visits
//          * an guest page, redirect to the homepage
//          */
//         next({
//             name: 'home',
//         });
//     } else {
//         next();
//     }
// });

router.beforeEach((to, from, next) => {
    store.commit('navbar/PREVIOUS_ROUTE_NAME', from.name);
    if (to.matched.some(record => record.meta.auth) && !store.getters['auth/logged']) {
        /**
         * If the user is not authenticated and visits
         * a page that requires authentication, redirect to the login page
         */
        next({
            name: 'auth.login',
            query: {
                redirect: to.fullPath,
            },
        });
    } else if (to.matched.some(record => record.meta.guest) && store.getters['auth/logged']) {
        /**
         * If the user is authenticated and visits
         * an guest page, redirect to the homepage
         */
        next({
            name: 'home',
        });
    } else if (store.getters['auth/logged'] && window.getAppStorage('type') === constants.COOKIE_TYPE_ADMIN) {
        /**
         * If the user is authenticated but not a student
         * redirect to admin
         */
        window.location.replace(`${window.location.protocol}//admin.${window.location.hostname}`);
    } else {
        next();
    }
});

sync(store, router);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js